module.exports = __webpack_public_path__ + "133b12d884960c3db26e03545ce3677f.png";